import Vue from 'vue'
import Router from 'vue-router'
import Welcome from './views/Welcome.vue'
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import Remind from './views/Remind.vue'
import Confirm from './views/Confirm.vue'
import Newpass from './views/Newpass.vue'
import Changepass from './views/Changepass.vue'
import Controllers from './views/Controllers.vue'
import Dashboard from './views/Dashboard.vue'
import Settings from './views/Settings.vue'
import Lang from './views/Lang.vue'
import Newcontroller from './views/Newcontroller.vue'
import Controller from './views/Controller.vue'
import ControllerSettings from './views/ControllerSettings.vue'
import SetBoilerTemp from './views/SetBoilerTemp.vue'
import SetBoilerWeather from './views/SetBoilerWeather.vue'
import SetBoilerCalendar from './views/SetBoilerCalendar.vue'
import SetCwTemp from './views/SetCwTemp.vue'
import SetCwCalendar from './views/SetCwCalendar.vue'
import SetValveTemp from './views/SetValveTemp.vue'
import SetValveWeather from './views/SetValveWeather.vue'
import SetValveCalendar from './views/SetValveCalendar.vue'
import ServerError from './views/ServerError.vue'
import Notifications from './views/Notifications.vue'
import Users from './views/Users.vue'
import Newuser from './views/Newuser.vue'
import DeleteController from './views/DeleteController.vue'
import Stats from './views/Stats.vue'

import TopControllers from './components/TopControllers.vue'
import TopController from './components/TopController.vue'
//import TopSubController from './components/TopSubController.vue'
import TopSubSet from './components/TopSubSet.vue'
import TopSubpage from './components/TopSubpage.vue'
import TopDefault from './components/TopDefault.vue'
import TopLogout from './components/TopLogout.vue'
//import FabControllers from './components/FabControllers.vue'
import FabController from './components/FabController.vue'
import FabUsers from './components/FabUsers.vue'
//import TopNotifications from './components/TopNotifications.vue'

import store from './store/'

//Vue.use(localStorage)
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { 
      path: '/index.html',
      components: {
        default: Welcome,
        top: TopLogout
      },
      alias: '/',
      meta: { title: '', hidemenu: true }
    },
    {
      path: '/',
      name: 'welcome',
      components: {
        default: Welcome,
        top: TopLogout
      },
      meta: { title: '', hidemenu: true }
    },
    {
      path: '/server-error',
      name: 'server-error',
      components: {
        default: ServerError,
        top: TopDefault
      },
      meta: { title: 'Error', hidemenu: true }
    },
    {
      path: '/controllers/new',
      name: 'newcontroller',
      components: {
        default: Newcontroller,
        top: TopSubpage
      },
      meta: { title: 'Moje sterowniki' },
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/controllers/:controllerId',
      name: 'controller',
      components: {
        default: Controller,
        top: TopController
      },
      meta: { title: 'Edycja sterownika' }
    },
    {
      path: '/controllers/delete/:controllerId',
      name: 'deletecontroller',
      components: {
        default: DeleteController,
        top: TopController
      },
      meta: { title: 'Edycja sterownika' }
    },
    {
      path: '/controller/:controllerId',
      name: 'controllerset',
      components: {
        default: ControllerSettings,
        top: TopController,
        fab: FabController
      },
      meta: { title: 'Edycja sterownika' }
    },
    {
      path: '/controllers',
      name: 'controllers',
      components: {
        default: Controllers,
        top: TopControllers
      },
      meta: { title: 'Moje sterowniki' },
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/dashboard/boiler-temp/:controllerId',
      name: 'boilerTemp',
      components: {
        default: SetBoilerTemp,
        top: TopSubSet
      },
      meta: { title: 'boilerTemp' }
    },
    {
      path: '/dashboard/boiler-calendar/:controllerId',
      name: 'boilerCalendar',
      components: {
        default: SetBoilerCalendar,
        top: TopSubSet
      },
      meta: { title: 'boilerCalendar' }
    },
    {
      path: '/dashboard/cw-temp/:controllerId',
      name: 'cwTemp',
      components: {
        default: SetCwTemp,
        top: TopSubSet
      },
      meta: { title: 'cwTemp' }
    },
    {
      path: '/dashboard/cw-calendar/:controllerId',
      name: 'cwCalendar',
      components: {
        default: SetCwCalendar,
        top: TopSubSet
      },
      meta: { title: 'cwCalendar' }
    },
    {
      path: '/dashboard/valve-temp/:controllerId',
      name: 'valveTemp',
      components: {
        default: SetValveTemp,
        top: TopSubSet
      },
      meta: { title: 'valveTemp' }
    },
    {
      path: '/dashboard/valve-weather/:controllerId',
      name: 'SetValveWeather',
      components: {
        default: SetValveWeather,
        top: TopSubSet
      },
      meta: { title: 'weatherMode' }
    },
    {
      path: '/dashboard/valve-calendar/:controllerId',
      name: 'valveCalendar',
      components: {
        default: SetValveCalendar,
        top: TopSubSet
      },
      meta: { title: 'valveCalendar' }
    },
    {
      path: '/dashboard/weather-mode/:controllerId',
      name: 'SetBoilerWeather',
      components: {
        default: SetBoilerWeather,
        top: TopSubSet
      },
      meta: { title: 'weatherMode' }
    },
    {
      path: '/notifications/:controllerId',
      name: 'notifications',
      components: {
        default: Notifications,
        top: TopController,
        fab: FabController
      },
      meta: { title: 'Powiadomienia'},
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/stats/:controllerId',
      name: 'stats',
      components: {
        default: Stats,
        top: TopController,
        fab: FabController
      },
      meta: { title: 'Statystyka'},
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/users/:controllerId',
      name: 'users',
      components: {
        default: Users,
        top: TopController,
        fab: FabController
      },
      meta: { title: 'Uzytkownicy'},
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/add-user/:controllerId',
      name: 'newuser',
      components: {
        default: Newuser,
        top: TopSubpage
      },
      meta: { title: 'Uzytkownicy' },
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/edit-user/:userId/:controllerId',
      name: 'eduser',
      components: {
        default: Newuser,
        top: TopSubpage
      },
      meta: { title: 'Uzytkownicy' },
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/dashboard/:controllerId',
      name: 'dashboard',
      components: {
        default: Dashboard,
        top: TopController,
        fab: FabController
      },
      meta: { title: 'Centrum sterowania' },
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/login',
      name: 'login',
      components: {
        default: Login,
        top: TopLogout
      },
      meta: { title: 'Logowanie', hidemenu: true }
    },
    {
      path: '/register',
      name: 'register',
      components: {
        default: Register,
        top: TopLogout
      },
      meta: { title: 'Rejestracja', hidemenu: true }
    },
    {
      path: '/remind',
      name: 'remind',
      components: {
        default: Remind,
        top: TopLogout
      },
      meta: { title: 'Przypomnienie', hidemenu: true }
    },
    {
      path: '/confirm/:token',
      name: 'confirm',
      components: {
        default: Confirm,
        top: TopLogout
      },
      meta: { title: 'Aktywacja', hidemenu: true }
    },
    {
      path: '/new-pass/:token',
      name: 'newpass',
      components: {
        default: Newpass,
        top: TopLogout
      },
      meta: { title: 'Nowe haslo', hidemenu: true }
    },
    {
      path: '/change-pass',
      name: 'change-pass',
      components: {
        default: Changepass,
        top: TopSubpage
      },
      meta: { title: 'zmiana-hasla', hidemenu: true },
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/settings/lang',
      name: 'lang',
      components: {
        default: Lang,
        top: TopSubpage
      },
      meta: { title: 'wybor jezyka', hidemenu: true }
    },
    {
      path: '/settings',
      name: 'settings',
      components: {
        default: Settings,
        top: TopDefault
      },
      meta: { title: 'Ustawienia'},
      beforeEnter (to, from, next) {
        if (store.getters.token != 0) { next() } else { next('/login') }
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
